import { render, staticRenderFns } from "./CiBrandKit.vue?vue&type=template&id=2e65b744&scoped=true"
import script from "./CiBrandKit.vue?vue&type=script&lang=js"
export * from "./CiBrandKit.vue?vue&type=script&lang=js"
import style0 from "./CiBrandKit.vue?vue&type=style&index=0&id=2e65b744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e65b744",
  null
  
)

export default component.exports